import "./landing.scss";

const Landing = () => {
  return (
    <div className="landing">
      <section className="header">
        <div className="title">
          <h1 className="title-h1">B L I Z Z A R D</h1>
          <p className="title-p">An ECS game engine and server</p>
        </div>
        <div className="buttons">
          <a
            target="_blank"
            rel="noreferrer"
            href="https://sebastiandominguezc.github.io/blizzard-book/book/learn.html"
            className="btn btn-primary"
          >
            Learn
          </a>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://docs.rs/blizzard-engine/0.1.0/blizzard_engine/"
            className="btn btn-secondary"
          >
            Docs
          </a>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://sebastiandominguezc.github.io/blizzard-book/book/roadmap.html"
            className="btn btn-tertiary"
          >
            Roadmap
          </a>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://github.com/SebastianDominguezC/blizzard"
            className="btn btn-black"
          >
            Repo
          </a>
        </div>
      </section>
      <section className="info"></section>
    </div>
  );
};

export default Landing;
